export function parseFloatToDecimals(stringToBeParsed, decimals) {
    return parseFloat(parseFloatUniversal(stringToBeParsed).toFixed(decimals));
}
export function parseFloatUniversal(stringToBeParse) {
    return parseFloat(stringToBeParse.toString().replace(',', '.'));
}
export function roundOptionalDigits(value, digits) {
    var multiplier = Math.pow(10, digits);
    return Math.round(value * multiplier) / multiplier;
}
